import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import OnboardingBackground from '../../components/OnboardingBackground';
import OnboardingCardTemplate from '../../components/OnboardingCardTemplate';
import AppHands from '../../assets/icons/app_hands.svg';
import { useAmplitude } from '../../providers/AmplitudeProvider';
import { ILink } from '../../services/link/types';
import { onWebAppReferralLinkLoaded } from '../../tracking/trackers';

const ReferralLinkType = ({
    linkToken,
    tokenData,
}: {
    linkToken: string;
    tokenData: ILink;
}) => {
    const navigate = useNavigate();
    const { isInitialized } = useAmplitude();

    useEffect(() => {
        if (isInitialized) {
            onWebAppReferralLinkLoaded({
                referral_token: linkToken,
                cohort: tokenData?.metadata?.cohort,
            });
        }
    }, [isInitialized]);

    const sourceName = tokenData?.user?.first_name || 'Someone';

    return (
        <>
            <OnboardingBackground>
                <OnboardingCardTemplate
                    title="Welcome to SimplyWise!"
                    subtitle={`Thanks to ${sourceName} who has referred you!`}
                    content={
                        <div
                            style={{
                                display: 'flex',
                                flexDirection: 'column',
                                alignItems: 'center',
                            }}
                        >
                            {/* <div
                            style={{
                                margin: 5,
                            }}
                        >
                            Download the app to access {categoryNames}!
                        </div> */}
                            <img
                                src={AppHands}
                                alt=""
                                width={150}
                                height={150}
                                style={{ marginTop: 30 }}
                            />
                            <div style={{ margin: 20 }} />
                        </div>
                    }
                    buttons={[
                        {
                            text: 'Continue in App',
                            onClick: () => {
                                navigate('/redirect-download', {
                                    state: {
                                        alternativeWebUrl: '/link/referral',
                                        customData: {
                                            link_token: linkToken,
                                        },
                                    },
                                });
                            },
                        },
                    ]}
                />
            </OnboardingBackground>
        </>
    );
};

export default ReferralLinkType;
